<template>
  <div class="main">
    <div class="main_bg">
      <div class="banner">
        <img id="bannerBg" src="https://www.csvw.com/u/cms/www/202601/12113135azN5.jpg" style="width: 100%" />
<!--        <div class="wenben">-->
<!--          <div class="group">-->
<!--            <img src="../../assets/image/esg/esg1.png" alt="">-->
<!--            <img src="../../assets/image/esg/esg2.png" alt="">-->
<!--            <img src="../../assets/image/esg/esg3.png" alt="">-->
<!--            <img src="../../assets/image/esg/esg4.png" alt="">-->
<!--            <img src="../../assets/image/esg/esg5.png" alt="">-->
<!--            <img src="../../assets/image/esg/esg6.png" alt="">-->
<!--          </div>-->
<!--          <div class="textWrapper">-->
<!--            <div>-->
<!--              四十载风云激荡，时代浪潮奔涌向前。站在新的历史坐标上回望，上汽大众的发展历程不仅是中国汽车工业现代化的生动缩影，更是中德合作持续深化、绿色创新不断突破、企业责任日益延伸的厚重见证。面对全球碳中和稳步推进的时代背景，上汽大众始终将环境、社会与治理（ESG）理念深度融入发展战略，全面拥抱新能源转型，并致力于成为：“合资新阶段的探路者和引领者”、“长期主义坚守者”以及“值得信赖的出行方案提供者”。-->
<!--            </div>-->
<!--            <div class="en">-->
<!--              Four decades of dynamic change and relentless progress have defined our era. As we stand at this new historical juncture and look back, SAIC VOLKSWAGEN's journey stands not only as a vivid reflection of China's automotive modernization, but also as a profound testament to the sustained deepening of Sino-German cooperation, continuous breakthroughs in green innovation, and the expanding scope of corporate responsibility. Against the backdrop of a global push toward carbon neutrality, SAIC VOLKSWAGEN has deeply integrated Environmental, Social, and Governance (ESG) principles into its strategic development, fully embracing the transition to new energy, striving to become “A Pioneer & Leader in Joint Venture”, “A Practitioner of Long-termism” and “A Reliable Mobility Solutions Provider”.-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->

      </div>
      <sceneMenuPc></sceneMenuPc>
      <scene1Pc v-if="layoutShow(0)"></scene1Pc>
      <scene2Pc v-if="layoutShow(1)"></scene2Pc>
      <scene3Pc v-if="layoutShow(2)"></scene3Pc>
      <scene4Pc v-if="layoutShow(3)"></scene4Pc>
      <scene5Pc v-if="layoutShow(4)"></scene5Pc>
      <sceneEndPc></sceneEndPc>
    </div>
  </div>
</template>

<script>
import scene1Pc from "./scene1Mobile.vue";
import scene2Pc from "./scene2Mobile.vue";
import scene3Pc from "./scene3Mobile.vue";
import scene4Pc from "./scene4Mobile.vue";
import scene5Pc from "./scene5Mobile.vue";
import sceneEndPc from "./sceneEndMobile.vue";
import sceneMenuPc from "./sceneMenuMobile.vue";
export default {
  components: {
    sceneMenuPc,
    sceneEndPc,
    scene1Pc,
    scene2Pc,
    scene3Pc,
    scene4Pc,
    scene5Pc,
  },
  data() {
    return {
      btnIndex: 0,
    };
  },
  beforeMount() { },
  mounted() {
    console.log(this);
  },
  methods: {
    // 板块是否展开
    layoutShow(val = 0) {
      if (val == this.btnIndex) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  // min-width: 375px;
  margin: 0px auto;
  font-size: 12px;
  font-family: FZYOUH_ZHONGXIJW;
}

.main_bg {
  width: 100%;
  // min-width: 375px;
  background: #F5F5F5;
}

.banner {
  position: relative;
  .wenben {
    position: absolute;
    bottom: 24px;
    left: 8px;
    right: 8px;
    .group {
      display: flex;
      gap: 4px;
      /* 图片之间的间距 */
      img {
        flex: 1;
        /* 关键属性：使图片等宽平分容器 */
        width: 0;
        /* 配合flex:1实现等宽 */
        height: auto;
        /* 保持原始宽高比 */
        object-fit: contain;
        /* 保持图片完整显示 */
      }
    }
    .textWrapper{
      line-height: 1.6;
      padding: 12px 6px;
      background-color: rgba(0, 0, 0, 0.25);
      font-size: 9px;
      color: #ffffff;
      margin-top: 12px;
    }
  }


}


</style>
